import { install as VueMonacoEditorPlugin } from "@guolao/vue-monaco-editor";

export default defineNuxtPlugin((app) => {
  app.vueApp.use(VueMonacoEditorPlugin);
});
